export const UPDATE_TOP_SKUS_WIDGET = "UPDATE_TOP_SKUS_WIDGET";